import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

export default function AdminLogin({ setUser }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      const userData = res.data.user;
      
      if (userData.role === 'org_admin') {
        // Redirect org_admin to their organization-specific login page
        toast.info('請使用機構管理員登入頁面');
        navigate(`/org-admin/login`);
        return;
      }
      
      // Strict role validation: only super_admin allowed
      if (userData.role !== 'super_admin') {
        localStorage.removeItem('token');
        const roleText = 
          userData.role === 'student' ? '學生' :
          userData.role === 'parent' ? '家長' :
          userData.role === 'coach' ? '教練' :
          userData.role === 'org_admin' ? '機構管理員' : '其他';
        toast.error(`此帳號是${roleText}帳號，請使用對應的登入頁面`);
        return;
      }

      localStorage.setItem('token', res.data.access_token);
      setUser(userData);
      toast.success('登入成功');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('用戶名稱或密碼錯誤');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-700">
      <div className="w-full max-w-md px-6">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-slate-800 rounded-2xl mx-auto mb-4 flex items-center justify-center">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-800">後台管理</h2>
            <p className="text-gray-600 mt-2">系統管理員登入</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Input
                data-testid="admin-username-input"
                type="text"
                placeholder="管理員用戶名"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="h-12"
              />
            </div>

            <div>
              <Input
                data-testid="admin-password-input"
                type="password"
                placeholder="密碼"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-12"
              />
            </div>

            <Button 
              data-testid="admin-login-btn"
              type="submit" 
              className="w-full h-12 text-lg bg-slate-800 hover:bg-slate-900"
              disabled={loading}
            >
              {loading ? '登入中...' : '登入'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
